/**
 * Splits a fill-in-the-blank sentence into alternating text and blank tokens.
 *
 * "I have _____ fingers on one hand."
 *   → [
 *       { type: 'text',  value: 'I have ' },
 *       { type: 'blank' },
 *       { type: 'text',  value: ' fingers on one hand.' },
 *     ]
 *
 * Recognises runs of 4 or more underscores as a blank marker.
 * If the sentence contains no blank markers the entire string is returned
 * as a single text token (the drop zone will appear at the end).
 */
export const parseBlanks = (text = '') => {
  const parts = [];
  const BLANK_RE = /_{4,}/g;
  let last = 0;
  let match;
  while ((match = BLANK_RE.exec(text)) !== null) {
    if (match.index > last) {
      parts.push({ type: 'text', value: text.slice(last, match.index) });
    }
    parts.push({ type: 'blank' });
    last = match.index + match[0].length;
  }
  if (last < text.length) {
    parts.push({ type: 'text', value: text.slice(last) });
  }
  // Sentence has no blank marker — treat the whole text as prefix,
  // blank will be appended at the end by the renderer.
  return parts.length ? parts : [{ type: 'text', value: text }];
};
